import { render, staticRenderFns } from "./UserRoutesAnchorCard.vue?vue&type=template&id=1cc81046&"
import script from "./UserRoutesAnchorCard.vue?vue&type=script&lang=js&"
export * from "./UserRoutesAnchorCard.vue?vue&type=script&lang=js&"
import style0 from "./UserRoutesAnchorCard.vue?vue&type=style&index=0&id=1cc81046&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports